import React from "react";
import { FormattedMessage } from "react-intl";
import TSDialog from "../../../general/dialog";

const AuthorizeDialog = props => {
  const {
    visibleAuthorizeDialog,
    toggleAuthorizeDialog,
    setAuthorize,
    accountantSelectedRagSoc,
    totalToPay,
    isManagerPays
  } = props;

  return (
    <TSDialog
      title={
        <FormattedMessage id="deadlines.pages.detail.confirmAuthorization" />
      }
      okText="Autorizza"
      visible={visibleAuthorizeDialog}
      onAbort={toggleAuthorizeDialog}
      onSubmit={e => {
        if (window.aptrinsic) {
          window.aptrinsic("track", "digital-box:DEADLINES-PAYMENT-AUTHORIZE");
        }
        setAuthorize();
        toggleAuthorizeDialog();
      }}
    >
      <FormattedMessage id="deadlines.pages.detail.authorizeDialogText1" />
      {accountantSelectedRagSoc}
      <FormattedMessage id="deadlines.pages.detail.authorizeDialogText2" />
      {totalToPay} €
      <FormattedMessage id="deadlines.pages.detail.authorizeDialogText3" />
      {isManagerPays ? (
        <FormattedMessage id="deadlines.pages.detail.authorizeDialogText4" />
      ) : (
        ""
      )}
      .
      <br />
      <br />
      <FormattedMessage id="deadlines.pages.detail.confirmQuestion" />
    </TSDialog>
  );
};

export default AuthorizeDialog;
